import { Plane } from "./Plane";
import { Ray } from "./Ray";
import { ContainmentType } from "./ContainmentType";
import { MathUtils3D } from "../../maths/MathUtils3D";
import { Vector3 } from "../../maths/Vector3";
export class CollisionUtils {
    constructor() {
    }
    static distancePlaneToPoint(plane, point) {
        var dot = Vector3.dot(plane.normal, point);
        return dot + plane.distance;
    }
    static distanceBoxToPoint(box, point) {
        var boxMin = box.min;
        var boxMineX = boxMin.x;
        var boxMineY = boxMin.y;
        var boxMineZ = boxMin.z;
        var boxMax = box.max;
        var boxMaxeX = boxMax.x;
        var boxMaxeY = boxMax.y;
        var boxMaxeZ = boxMax.z;
        var pointeX = point.x;
        var pointeY = point.y;
        var pointeZ = point.z;
        var distance = 0;
        if (pointeX < boxMineX)
            distance += (boxMineX - pointeX) * (boxMineX - pointeX);
        if (pointeX > boxMaxeX)
            distance += (boxMaxeX - pointeX) * (boxMaxeX - pointeX);
        if (pointeY < boxMineY)
            distance += (boxMineY - pointeY) * (boxMineY - pointeY);
        if (pointeY > boxMaxeY)
            distance += (boxMaxeY - pointeY) * (boxMaxeY - pointeY);
        if (pointeZ < boxMineZ)
            distance += (boxMineZ - pointeZ) * (boxMineZ - pointeZ);
        if (pointeZ > boxMaxeZ)
            distance += (boxMaxeZ - pointeZ) * (boxMaxeZ - pointeZ);
        return Math.sqrt(distance);
    }
    static distanceBoxToBox(box1, box2) {
        var box1Mine = box1.min;
        var box1MineX = box1Mine.x;
        var box1MineY = box1Mine.y;
        var box1MineZ = box1Mine.z;
        var box1Maxe = box1.max;
        var box1MaxeX = box1Maxe.x;
        var box1MaxeY = box1Maxe.y;
        var box1MaxeZ = box1Maxe.z;
        var box2Mine = box2.min;
        var box2MineX = box2Mine.x;
        var box2MineY = box2Mine.y;
        var box2MineZ = box2Mine.z;
        var box2Maxe = box2.max;
        var box2MaxeX = box2Maxe.x;
        var box2MaxeY = box2Maxe.y;
        var box2MaxeZ = box2Maxe.z;
        var distance = 0;
        var delta;
        if (box1MineX > box2MaxeX) {
            delta = box1MineX - box2MaxeX;
            distance += delta * delta;
        }
        else if (box2MineX > box1MaxeX) {
            delta = box2MineX - box1MaxeX;
            distance += delta * delta;
        }
        if (box1MineY > box2MaxeY) {
            delta = box1MineY - box2MaxeY;
            distance += delta * delta;
        }
        else if (box2MineY > box1MaxeY) {
            delta = box2MineY - box1MaxeY;
            distance += delta * delta;
        }
        if (box1MineZ > box2MaxeZ) {
            delta = box1MineZ - box2MaxeZ;
            distance += delta * delta;
        }
        else if (box2MineZ > box1MaxeZ) {
            delta = box2MineZ - box1MaxeZ;
            distance += delta * delta;
        }
        return Math.sqrt(distance);
    }
    static distanceSphereToPoint(sphere, point) {
        var distance = Math.sqrt(Vector3.distanceSquared(sphere.center, point));
        distance -= sphere.radius;
        return Math.max(distance, 0);
    }
    static distanceSphereToSphere(sphere1, sphere2) {
        var distance = Math.sqrt(Vector3.distanceSquared(sphere1.center, sphere2.center));
        distance -= sphere1.radius + sphere2.radius;
        return Math.max(distance, 0);
    }
    static intersectsRayAndTriangleRD(ray, vertex1, vertex2, vertex3, out) {
        var rayO = ray.origin;
        var rayOeX = rayO.x;
        var rayOeY = rayO.y;
        var rayOeZ = rayO.z;
        var rayD = ray.direction;
        var rayDeX = rayD.x;
        var rayDeY = rayD.y;
        var rayDeZ = rayD.z;
        var v1eX = vertex1.x;
        var v1eY = vertex1.y;
        var v1eZ = vertex1.z;
        var v2eX = vertex2.x;
        var v2eY = vertex2.y;
        var v2eZ = vertex2.z;
        var v3eX = vertex3.x;
        var v3eY = vertex3.y;
        var v3eZ = vertex3.z;
        var _tempV30eX = _tempV30.x;
        var _tempV30eY = _tempV30.y;
        var _tempV30eZ = _tempV30.z;
        _tempV30eX = v2eX - v1eX;
        _tempV30eY = v2eY - v1eY;
        _tempV30eZ = v2eZ - v1eZ;
        var _tempV31eX = _tempV31.x;
        var _tempV31eY = _tempV31.y;
        var _tempV31eZ = _tempV31.z;
        _tempV31eX = v3eX - v1eX;
        _tempV31eY = v3eY - v1eY;
        _tempV31eZ = v3eZ - v1eZ;
        var _tempV32eX = _tempV32.x;
        var _tempV32eY = _tempV32.y;
        var _tempV32eZ = _tempV32.z;
        _tempV32eX = (rayDeY * _tempV31eZ) - (rayDeZ * _tempV31eY);
        _tempV32eY = (rayDeZ * _tempV31eX) - (rayDeX * _tempV31eZ);
        _tempV32eZ = (rayDeX * _tempV31eY) - (rayDeY * _tempV31eX);
        var determinant = (_tempV30eX * _tempV32eX) + (_tempV30eY * _tempV32eY) + (_tempV30eZ * _tempV32eZ);
        if (MathUtils3D.isZero(determinant)) {
            out = 0;
            return false;
        }
        var inversedeterminant = 1 / determinant;
        var _tempV33eX = _tempV33.x;
        var _tempV33eY = _tempV33.y;
        var _tempV33eZ = _tempV33.z;
        _tempV33eX = rayOeX - v1eX;
        _tempV33eY = rayOeY - v1eY;
        _tempV33eZ = rayOeZ - v1eZ;
        var triangleU = (_tempV33eX * _tempV32eX) + (_tempV33eY * _tempV32eY) + (_tempV33eZ * _tempV32eZ);
        triangleU *= inversedeterminant;
        if (triangleU < 0 || triangleU > 1) {
            out = 0;
            return false;
        }
        var _tempV34eX = _tempV34.x;
        var _tempV34eY = _tempV34.y;
        var _tempV34eZ = _tempV34.z;
        _tempV34eX = (_tempV33eY * _tempV30eZ) - (_tempV33eZ * _tempV30eY);
        _tempV34eY = (_tempV33eZ * _tempV30eX) - (_tempV33eX * _tempV30eZ);
        _tempV34eZ = (_tempV33eX * _tempV30eY) - (_tempV33eY * _tempV30eX);
        var triangleV = ((rayDeX * _tempV34eX) + (rayDeY * _tempV34eY)) + (rayDeZ * _tempV34eZ);
        triangleV *= inversedeterminant;
        if (triangleV < 0 || triangleU + triangleV > 1) {
            out = 0;
            return false;
        }
        var raydistance = (_tempV31eX * _tempV34eX) + (_tempV31eY * _tempV34eY) + (_tempV31eZ * _tempV34eZ);
        raydistance *= inversedeterminant;
        if (raydistance < 0) {
            out = 0;
            return false;
        }
        out = raydistance;
        return true;
    }
    static intersectsRayAndTriangleRP(ray, vertex1, vertex2, vertex3, out) {
        var distance;
        if (!CollisionUtils.intersectsRayAndTriangleRD(ray, vertex1, vertex2, vertex3, distance)) {
            Vector3.ZERO.cloneTo(out);
            return false;
        }
        Vector3.scale(ray.direction, distance, _tempV30);
        Vector3.add(ray.origin, _tempV30, out);
        return true;
    }
    static intersectsRayAndPoint(ray, point) {
        Vector3.subtract(ray.origin, point, _tempV30);
        var b = Vector3.dot(_tempV30, ray.direction);
        var c = Vector3.dot(_tempV30, _tempV30) - MathUtils3D.zeroTolerance;
        if (c > 0 && b > 0)
            return false;
        var discriminant = b * b - c;
        if (discriminant < 0)
            return false;
        return true;
    }
    static intersectsRayAndRay(ray1, ray2, out) {
        var ray1o = ray1.origin;
        var ray1oeX = ray1o.x;
        var ray1oeY = ray1o.y;
        var ray1oeZ = ray1o.z;
        var ray1d = ray1.direction;
        var ray1deX = ray1d.x;
        var ray1deY = ray1d.y;
        var ray1deZ = ray1d.z;
        var ray2o = ray2.origin;
        var ray2oeX = ray2o.x;
        var ray2oeY = ray2o.y;
        var ray2oeZ = ray2o.z;
        var ray2d = ray2.direction;
        var ray2deX = ray2d.x;
        var ray2deY = ray2d.y;
        var ray2deZ = ray2d.z;
        Vector3.cross(ray1d, ray2d, _tempV30);
        var tempV3 = _tempV30;
        var denominator = Vector3.scalarLength(_tempV30);
        if (MathUtils3D.isZero(denominator)) {
            if (MathUtils3D.nearEqual(ray2oeX, ray1oeX) && MathUtils3D.nearEqual(ray2oeY, ray1oeY) && MathUtils3D.nearEqual(ray2oeZ, ray1oeZ)) {
                Vector3.ZERO.cloneTo(out);
                return true;
            }
        }
        denominator = denominator * denominator;
        var m11 = ray2oeX - ray1oeX;
        var m12 = ray2oeY - ray1oeY;
        var m13 = ray2oeZ - ray1oeZ;
        var m21 = ray2deX;
        var m22 = ray2deY;
        var m23 = ray2deZ;
        var m31 = tempV3.x;
        var m32 = tempV3.y;
        var m33 = tempV3.z;
        var dets = m11 * m22 * m33 + m12 * m23 * m31 + m13 * m21 * m32 - m11 * m23 * m32 - m12 * m21 * m33 - m13 * m22 * m31;
        m21 = ray1deX;
        m22 = ray1deY;
        m23 = ray1deZ;
        var s = dets / denominator;
        Vector3.scale(ray1d, s, _tempV30);
        Vector3.scale(ray2d, s, _tempV31);
        Vector3.add(ray1o, _tempV30, _tempV32);
        Vector3.add(ray2o, _tempV31, _tempV33);
        var point1e = _tempV32;
        var point2e = _tempV33;
        if (!MathUtils3D.nearEqual(point2e.x, point1e.x) || !MathUtils3D.nearEqual(point2e.y, point1e.y) || !MathUtils3D.nearEqual(point2e.z, point1e.z)) {
            Vector3.ZERO.cloneTo(out);
            return false;
        }
        out = _tempV32;
        return true;
    }
    static intersectsPlaneAndTriangle(plane, vertex1, vertex2, vertex3) {
        var test1 = CollisionUtils.intersectsPlaneAndPoint(plane, vertex1);
        var test2 = CollisionUtils.intersectsPlaneAndPoint(plane, vertex2);
        var test3 = CollisionUtils.intersectsPlaneAndPoint(plane, vertex3);
        if (test1 == Plane.PlaneIntersectionType_Front && test2 == Plane.PlaneIntersectionType_Front && test3 == Plane.PlaneIntersectionType_Front)
            return Plane.PlaneIntersectionType_Front;
        if (test1 == Plane.PlaneIntersectionType_Back && test2 == Plane.PlaneIntersectionType_Back && test3 == Plane.PlaneIntersectionType_Back)
            return Plane.PlaneIntersectionType_Back;
        return Plane.PlaneIntersectionType_Intersecting;
    }
    static intersectsRayAndPlaneRD(ray, plane) {
        var planeNor = plane.normal;
        var direction = Vector3.dot(planeNor, ray.direction);
        if (Math.abs(direction) < MathUtils3D.zeroTolerance)
            return -1;
        var position = Vector3.dot(planeNor, ray.origin);
        var distance = (-plane.distance - position) / direction;
        if (distance < 0) {
            if (distance < -MathUtils3D.zeroTolerance)
                return -1;
            distance = 0;
        }
        return distance;
    }
    static intersectsRayAndPlaneRP(ray, plane, out) {
        var distance = CollisionUtils.intersectsRayAndPlaneRD(ray, plane);
        if (distance == -1) {
            out.setValue(0, 0, 0);
            return false;
        }
        var scaDis = _tempV30;
        Vector3.scale(ray.direction, distance, scaDis);
        Vector3.add(ray.origin, scaDis, out);
        return true;
    }
    static intersectsRayAndBoxRD(ray, box) {
        var rayoe = ray.origin;
        var rayoeX = rayoe.x;
        var rayoeY = rayoe.y;
        var rayoeZ = rayoe.z;
        var rayde = ray.direction;
        var raydeX = rayde.x;
        var raydeY = rayde.y;
        var raydeZ = rayde.z;
        var boxMine = box.min;
        var boxMineX = boxMine.x;
        var boxMineY = boxMine.y;
        var boxMineZ = boxMine.z;
        var boxMaxe = box.max;
        var boxMaxeX = boxMaxe.x;
        var boxMaxeY = boxMaxe.y;
        var boxMaxeZ = boxMaxe.z;
        var out = 0;
        var tmax = MathUtils3D.MaxValue;
        if (MathUtils3D.isZero(raydeX)) {
            if (rayoeX < boxMineX || rayoeX > boxMaxeX) {
                return -1;
            }
        }
        else {
            var inverse = 1 / raydeX;
            var t1 = (boxMineX - rayoeX) * inverse;
            var t2 = (boxMaxeX - rayoeX) * inverse;
            if (t1 > t2) {
                var temp = t1;
                t1 = t2;
                t2 = temp;
            }
            out = Math.max(t1, out);
            tmax = Math.min(t2, tmax);
            if (out > tmax) {
                return -1;
            }
        }
        if (MathUtils3D.isZero(raydeY)) {
            if (rayoeY < boxMineY || rayoeY > boxMaxeY) {
                return -1;
            }
        }
        else {
            var inverse1 = 1 / raydeY;
            var t3 = (boxMineY - rayoeY) * inverse1;
            var t4 = (boxMaxeY - rayoeY) * inverse1;
            if (t3 > t4) {
                var temp1 = t3;
                t3 = t4;
                t4 = temp1;
            }
            out = Math.max(t3, out);
            tmax = Math.min(t4, tmax);
            if (out > tmax) {
                return -1;
            }
        }
        if (MathUtils3D.isZero(raydeZ)) {
            if (rayoeZ < boxMineZ || rayoeZ > boxMaxeZ) {
                return -1;
            }
        }
        else {
            var inverse2 = 1 / raydeZ;
            var t5 = (boxMineZ - rayoeZ) * inverse2;
            var t6 = (boxMaxeZ - rayoeZ) * inverse2;
            if (t5 > t6) {
                var temp2 = t5;
                t5 = t6;
                t6 = temp2;
            }
            out = Math.max(t5, out);
            tmax = Math.min(t6, tmax);
            if (out > tmax) {
                return -1;
            }
        }
        return out;
    }
    static intersectsRayAndBoxRP(ray, box, out) {
        var distance = CollisionUtils.intersectsRayAndBoxRD(ray, box);
        if (distance === -1) {
            Vector3.ZERO.cloneTo(out);
            return distance;
        }
        Vector3.scale(ray.direction, distance, _tempV30);
        Vector3.add(ray.origin, _tempV30, _tempV31);
        _tempV31.cloneTo(out);
        return distance;
    }
    static intersectsRayAndSphereRD(ray, sphere) {
        var sphereR = sphere.radius;
        Vector3.subtract(ray.origin, sphere.center, _tempV30);
        var b = Vector3.dot(_tempV30, ray.direction);
        var c = Vector3.dot(_tempV30, _tempV30) - (sphereR * sphereR);
        if (c > 0 && b > 0) {
            return -1;
        }
        var discriminant = b * b - c;
        if (discriminant < 0) {
            return -1;
        }
        var distance = -b - Math.sqrt(discriminant);
        if (distance < 0)
            distance = 0;
        return distance;
    }
    static intersectsRayAndSphereRP(ray, sphere, out) {
        var distance = CollisionUtils.intersectsRayAndSphereRD(ray, sphere);
        if (distance === -1) {
            Vector3.ZERO.cloneTo(out);
            return distance;
        }
        Vector3.scale(ray.direction, distance, _tempV30);
        Vector3.add(ray.origin, _tempV30, _tempV31);
        _tempV31.cloneTo(out);
        return distance;
    }
    static intersectsSphereAndTriangle(sphere, vertex1, vertex2, vertex3) {
        var sphereC = sphere.center;
        var sphereR = sphere.radius;
        CollisionUtils.closestPointPointTriangle(sphereC, vertex1, vertex2, vertex3, _tempV30);
        Vector3.subtract(_tempV30, sphereC, _tempV31);
        var dot = Vector3.dot(_tempV31, _tempV31);
        return dot <= sphereR * sphereR;
    }
    static intersectsPlaneAndPoint(plane, point) {
        var distance = Vector3.dot(plane.normal, point) + plane.distance;
        if (distance > 0)
            return Plane.PlaneIntersectionType_Front;
        if (distance < 0)
            return Plane.PlaneIntersectionType_Back;
        return Plane.PlaneIntersectionType_Intersecting;
    }
    static intersectsPlaneAndPlane(plane1, plane2) {
        Vector3.cross(plane1.normal, plane2.normal, _tempV30);
        var denominator = Vector3.dot(_tempV30, _tempV30);
        if (MathUtils3D.isZero(denominator))
            return false;
        return true;
    }
    static intersectsPlaneAndPlaneRL(plane1, plane2, line) {
        var plane1nor = plane1.normal;
        var plane2nor = plane2.normal;
        Vector3.cross(plane1nor, plane2nor, _tempV34);
        var denominator = Vector3.dot(_tempV34, _tempV34);
        if (MathUtils3D.isZero(denominator))
            return false;
        Vector3.scale(plane2nor, plane1.distance, _tempV30);
        Vector3.scale(plane1nor, plane2.distance, _tempV31);
        Vector3.subtract(_tempV30, _tempV31, _tempV32);
        Vector3.cross(_tempV32, _tempV34, _tempV33);
        Vector3.normalize(_tempV34, _tempV34);
        line = new Ray(_tempV33, _tempV34);
        return true;
    }
    static intersectsPlaneAndBox(plane, box) {
        var planeD = plane.distance;
        var planeNor = plane.normal;
        var planeNoreX = planeNor.x;
        var planeNoreY = planeNor.y;
        var planeNoreZ = planeNor.z;
        var boxMine = box.min;
        var boxMineX = boxMine.x;
        var boxMineY = boxMine.y;
        var boxMineZ = boxMine.z;
        var boxMaxe = box.max;
        var boxMaxeX = boxMaxe.x;
        var boxMaxeY = boxMaxe.y;
        var boxMaxeZ = boxMaxe.z;
        _tempV30.x = (planeNoreX > 0) ? boxMineX : boxMaxeX;
        _tempV30.y = (planeNoreY > 0) ? boxMineY : boxMaxeY;
        _tempV30.z = (planeNoreZ > 0) ? boxMineZ : boxMaxeZ;
        _tempV31.x = (planeNoreX > 0) ? boxMaxeX : boxMineX;
        _tempV31.y = (planeNoreY > 0) ? boxMaxeY : boxMineY;
        _tempV31.z = (planeNoreZ > 0) ? boxMaxeZ : boxMineZ;
        var distance = Vector3.dot(planeNor, _tempV30);
        if (distance + planeD > 0)
            return Plane.PlaneIntersectionType_Front;
        distance = Vector3.dot(planeNor, _tempV31);
        if (distance + planeD < 0)
            return Plane.PlaneIntersectionType_Back;
        return Plane.PlaneIntersectionType_Intersecting;
    }
    static intersectsPlaneAndSphere(plane, sphere) {
        var sphereR = sphere.radius;
        var distance = Vector3.dot(plane.normal, sphere.center) + plane.distance;
        if (distance > sphereR)
            return Plane.PlaneIntersectionType_Front;
        if (distance < -sphereR)
            return Plane.PlaneIntersectionType_Back;
        return Plane.PlaneIntersectionType_Intersecting;
    }
    static intersectsBoxAndBox(box1, box2) {
        var box1Mine = box1.min;
        var box1Maxe = box1.max;
        var box2Mine = box2.min;
        var box2Maxe = box2.max;
        if (box1Mine.x > box2Maxe.x || box2Mine.x > box1Maxe.x)
            return false;
        if (box1Mine.y > box2Maxe.y || box2Mine.y > box1Maxe.y)
            return false;
        if (box1Mine.z > box2Maxe.z || box2Mine.z > box1Maxe.z)
            return false;
        return true;
    }
    static intersectsBoxAndSphere(box, sphere) {
        var center = sphere.center;
        var radius = sphere.radius;
        var nearest = _tempV30;
        Vector3.Clamp(center, box.min, box.max, nearest);
        var distance = Vector3.distanceSquared(center, nearest);
        return distance <= radius * radius;
    }
    static intersectsSphereAndSphere(sphere1, sphere2) {
        var radiisum = sphere1.radius + sphere2.radius;
        return Vector3.distanceSquared(sphere1.center, sphere2.center) <= radiisum * radiisum;
    }
    static boxContainsPoint(box, point) {
        var boxMine = box.min;
        var boxMaxe = box.max;
        if (boxMine.x <= point.x && boxMaxe.x >= point.x && boxMine.y <= point.y && boxMaxe.y >= point.y && boxMine.z <= point.z && boxMaxe.z >= point.z)
            return ContainmentType.Contains;
        return ContainmentType.Disjoint;
    }
    static boxContainsBox(box1, box2) {
        var box1Mine = box1.min;
        var box1MineX = box1Mine.x;
        var box1MineY = box1Mine.y;
        var box1MineZ = box1Mine.z;
        var box1Maxe = box1.max;
        var box1MaxeX = box1Maxe.x;
        var box1MaxeY = box1Maxe.y;
        var box1MaxeZ = box1Maxe.z;
        var box2Mine = box2.min;
        var box2MineX = box2Mine.x;
        var box2MineY = box2Mine.y;
        var box2MineZ = box2Mine.z;
        var box2Maxe = box2.max;
        var box2MaxeX = box2Maxe.x;
        var box2MaxeY = box2Maxe.y;
        var box2MaxeZ = box2Maxe.z;
        if (box1MaxeX < box2MineX || box1MineX > box2MaxeX)
            return ContainmentType.Disjoint;
        if (box1MaxeY < box2MineY || box1MineY > box2MaxeY)
            return ContainmentType.Disjoint;
        if (box1MaxeZ < box2MineZ || box1MineZ > box2MaxeZ)
            return ContainmentType.Disjoint;
        if (box1MineX <= box2MineX && box2MaxeX <= box1MaxeX && box1MineY <= box2MineY && box2MaxeY <= box1MaxeY && box1MineZ <= box2MineZ && box2MaxeZ <= box1MaxeZ) {
            return ContainmentType.Contains;
        }
        return ContainmentType.Intersects;
    }
    static boxContainsSphere(box, sphere) {
        var boxMin = box.min;
        var boxMineX = boxMin.x;
        var boxMineY = boxMin.y;
        var boxMineZ = boxMin.z;
        var boxMax = box.max;
        var boxMaxeX = boxMax.x;
        var boxMaxeY = boxMax.y;
        var boxMaxeZ = boxMax.z;
        var sphereC = sphere.center;
        var sphereCeX = sphereC.x;
        var sphereCeY = sphereC.y;
        var sphereCeZ = sphereC.z;
        var sphereR = sphere.radius;
        Vector3.Clamp(sphereC, boxMin, boxMax, _tempV30);
        var distance = Vector3.distanceSquared(sphereC, _tempV30);
        if (distance > sphereR * sphereR)
            return ContainmentType.Disjoint;
        if ((((boxMineX + sphereR <= sphereCeX) && (sphereCeX <= boxMaxeX - sphereR)) && ((boxMaxeX - boxMineX > sphereR) &&
            (boxMineY + sphereR <= sphereCeY))) && (((sphereCeY <= boxMaxeY - sphereR) && (boxMaxeY - boxMineY > sphereR)) &&
            (((boxMineZ + sphereR <= sphereCeZ) && (sphereCeZ <= boxMaxeZ - sphereR)) && (boxMaxeZ - boxMineZ > sphereR))))
            return ContainmentType.Contains;
        return ContainmentType.Intersects;
    }
    static sphereContainsPoint(sphere, point) {
        if (Vector3.distanceSquared(point, sphere.center) <= sphere.radius * sphere.radius)
            return ContainmentType.Contains;
        return ContainmentType.Disjoint;
    }
    static sphereContainsTriangle(sphere, vertex1, vertex2, vertex3) {
        var test1 = CollisionUtils.sphereContainsPoint(sphere, vertex1);
        var test2 = CollisionUtils.sphereContainsPoint(sphere, vertex2);
        var test3 = CollisionUtils.sphereContainsPoint(sphere, vertex3);
        if (test1 == ContainmentType.Contains && test2 == ContainmentType.Contains && test3 == ContainmentType.Contains)
            return ContainmentType.Contains;
        if (CollisionUtils.intersectsSphereAndTriangle(sphere, vertex1, vertex2, vertex3))
            return ContainmentType.Intersects;
        return ContainmentType.Disjoint;
    }
    static sphereContainsBox(sphere, box) {
        var sphereC = sphere.center;
        var sphereCeX = sphereC.x;
        var sphereCeY = sphereC.y;
        var sphereCeZ = sphereC.z;
        var sphereR = sphere.radius;
        var boxMin = box.min;
        var boxMineX = boxMin.x;
        var boxMineY = boxMin.y;
        var boxMineZ = boxMin.z;
        var boxMax = box.max;
        var boxMaxeX = boxMax.x;
        var boxMaxeY = boxMax.y;
        var boxMaxeZ = boxMax.z;
        var _tempV30e = _tempV30;
        var _tempV30eX = _tempV30e.x;
        var _tempV30eY = _tempV30e.y;
        var _tempV30eZ = _tempV30e.z;
        if (!CollisionUtils.intersectsBoxAndSphere(box, sphere))
            return ContainmentType.Disjoint;
        var radiusSquared = sphereR * sphereR;
        _tempV30eX = sphereCeX - boxMineX;
        _tempV30eY = sphereCeY - boxMaxeY;
        _tempV30eZ = sphereCeZ - boxMaxeZ;
        if (Vector3.scalarLengthSquared(_tempV30) > radiusSquared)
            return ContainmentType.Intersects;
        _tempV30eX = sphereCeX - boxMaxeX;
        _tempV30eY = sphereCeY - boxMaxeY;
        _tempV30eZ = sphereCeZ - boxMaxeZ;
        if (Vector3.scalarLengthSquared(_tempV30) > radiusSquared)
            return ContainmentType.Intersects;
        _tempV30eX = sphereCeX - boxMaxeX;
        _tempV30eY = sphereCeY - boxMineY;
        _tempV30eZ = sphereCeZ - boxMaxeZ;
        if (Vector3.scalarLengthSquared(_tempV30) > radiusSquared)
            return ContainmentType.Intersects;
        _tempV30eX = sphereCeX - boxMineX;
        _tempV30eY = sphereCeY - boxMineY;
        _tempV30eZ = sphereCeZ - boxMaxeZ;
        if (Vector3.scalarLengthSquared(_tempV30) > radiusSquared)
            return ContainmentType.Intersects;
        _tempV30eX = sphereCeX - boxMineX;
        _tempV30eY = sphereCeY - boxMaxeY;
        _tempV30eZ = sphereCeZ - boxMineZ;
        if (Vector3.scalarLengthSquared(_tempV30) > radiusSquared)
            return ContainmentType.Intersects;
        _tempV30eX = sphereCeX - boxMaxeX;
        _tempV30eY = sphereCeY - boxMaxeY;
        _tempV30eZ = sphereCeZ - boxMineZ;
        if (Vector3.scalarLengthSquared(_tempV30) > radiusSquared)
            return ContainmentType.Intersects;
        _tempV30eX = sphereCeX - boxMaxeX;
        _tempV30eY = sphereCeY - boxMineY;
        _tempV30eZ = sphereCeZ - boxMineZ;
        if (Vector3.scalarLengthSquared(_tempV30) > radiusSquared)
            return ContainmentType.Intersects;
        _tempV30eX = sphereCeX - boxMineX;
        _tempV30eY = sphereCeY - boxMineY;
        _tempV30eZ = sphereCeZ - boxMineZ;
        if (Vector3.scalarLengthSquared(_tempV30) > radiusSquared)
            return ContainmentType.Intersects;
        return ContainmentType.Contains;
    }
    static sphereContainsSphere(sphere1, sphere2) {
        var sphere1R = sphere1.radius;
        var sphere2R = sphere2.radius;
        var distance = Vector3.distance(sphere1.center, sphere2.center);
        if (sphere1R + sphere2R < distance)
            return ContainmentType.Disjoint;
        if (sphere1R - sphere2R < distance)
            return ContainmentType.Intersects;
        return ContainmentType.Contains;
    }
    static closestPointPointTriangle(point, vertex1, vertex2, vertex3, out) {
        Vector3.subtract(vertex2, vertex1, _tempV30);
        Vector3.subtract(vertex3, vertex1, _tempV31);
        Vector3.subtract(point, vertex1, _tempV32);
        Vector3.subtract(point, vertex2, _tempV33);
        Vector3.subtract(point, vertex3, _tempV34);
        var d1 = Vector3.dot(_tempV30, _tempV32);
        var d2 = Vector3.dot(_tempV31, _tempV32);
        var d3 = Vector3.dot(_tempV30, _tempV33);
        var d4 = Vector3.dot(_tempV31, _tempV33);
        var d5 = Vector3.dot(_tempV30, _tempV34);
        var d6 = Vector3.dot(_tempV31, _tempV34);
        if (d1 <= 0 && d2 <= 0) {
            vertex1.cloneTo(out);
            return;
        }
        if (d3 >= 0 && d4 <= d3) {
            vertex2.cloneTo(out);
            return;
        }
        var vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            var v = d1 / (d1 - d3);
            Vector3.scale(_tempV30, v, out);
            Vector3.add(vertex1, out, out);
            return;
        }
        if (d6 >= 0 && d5 <= d6) {
            vertex3.cloneTo(out);
            return;
        }
        var vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            var w = d2 / (d2 - d6);
            Vector3.scale(_tempV31, w, out);
            Vector3.add(vertex1, out, out);
            return;
        }
        var va = d3 * d6 - d5 * d4;
        if (va <= 0 && (d4 - d3) >= 0 && (d5 - d6) >= 0) {
            var w3 = (d4 - d3) / ((d4 - d3) + (d5 - d6));
            Vector3.subtract(vertex3, vertex2, out);
            Vector3.scale(out, w3, out);
            Vector3.add(vertex2, out, out);
            return;
        }
        var denom = 1 / (va + vb + vc);
        var v2 = vb * denom;
        var w2 = vc * denom;
        Vector3.scale(_tempV30, v2, _tempV35);
        Vector3.scale(_tempV31, w2, _tempV36);
        Vector3.add(_tempV35, _tempV36, out);
        Vector3.add(vertex1, out, out);
    }
    static closestPointPlanePoint(plane, point, out) {
        var planeN = plane.normal;
        var t = Vector3.dot(planeN, point) - plane.distance;
        Vector3.scale(planeN, t, _tempV30);
        Vector3.subtract(point, _tempV30, out);
    }
    static closestPointBoxPoint(box, point, out) {
        Vector3.max(point, box.min, _tempV30);
        Vector3.min(_tempV30, box.max, out);
    }
    static closestPointSpherePoint(sphere, point, out) {
        var sphereC = sphere.center;
        Vector3.subtract(point, sphereC, out);
        Vector3.normalize(out, out);
        Vector3.scale(out, sphere.radius, out);
        Vector3.add(out, sphereC, out);
    }
    static closestPointSphereSphere(sphere1, sphere2, out) {
        var sphere1C = sphere1.center;
        Vector3.subtract(sphere2.center, sphere1C, out);
        Vector3.normalize(out, out);
        Vector3.scale(out, sphere1.radius, out);
        Vector3.add(out, sphere1C, out);
    }
}
const _tempV30 = new Vector3();
const _tempV31 = new Vector3();
const _tempV32 = new Vector3();
const _tempV33 = new Vector3();
const _tempV34 = new Vector3();
const _tempV35 = new Vector3();
const _tempV36 = new Vector3();
